import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from "@angular/core";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {Subscription} from "rxjs/Subscription";
import {Location} from "@angular/common";
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-age-verification',
  templateUrl: './age-verification.component.html',
  styleUrls: ['./age-verification.component.scss']
})
export class AgeVerificationComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild("content") template: TemplateRef<any>;
  public modalRef: any;
  private subscriptions: { [name: string]: Subscription } = {};

  minDrawAge: number;
  ageOption: string;
  error = false;

  private modalOptions: NgbModalOptions = {
    backdrop: "static",
    windowClass: "patient-details",
    keyboard: false
  };

  constructor(private readonly modalService: NgbModal,
              public readonly router: Router,
              public readonly route: ActivatedRoute,
              private readonly location: Location,
              private readonly store: Store<any>) {
  }

  ngOnInit() {

    this.subscriptions["system"] = this.store.select("userSession")
      .subscribe(data => {
        this.minDrawAge = data.Facility.System.MinimumDrawAge;
      })

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.modalOptions);
    });
  }

  handleCancel() {
    this.location.back();
  }

  handleNext() {
    if (this.ageOption === "no") {
      this.error = true;
    } else if (this.ageOption === "yes") {
        this.router.navigate(["../profile"],
          {relativeTo: this.route}).then()
    }
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });

    for (let sub in this.subscriptions) {
      if (this.subscriptions.hasOwnProperty(sub)) {
        this.subscriptions[sub].unsubscribe();
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/age-verification/age-verification.component.ts